var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isOpen,
          expression: "isOpen",
        },
      ],
      staticClass:
        "fixed top-0 left-0 z-50 w-screen h-screen modal-container modal--row",
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal__inner z-30 md:mx-0 h-full bg-cover overflow-y-scroll relative",
          class: _vm.bg ? _vm.bg : "",
        },
        [
          _c(
            "span",
            {
              staticClass: "modular-modal-close absolute z-50 cursor-pointer",
              class: { outer: _vm.closeLocation === "outer" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("close")
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "29",
                    height: "30",
                    viewBox: "0 0 29 30",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("line", {
                    attrs: {
                      x1: "28.3536",
                      y1: "1.35355",
                      x2: "0.353553",
                      y2: "29.3536",
                      stroke: "white",
                    },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: {
                      x1: "0.353553",
                      y1: "0.646447",
                      x2: "28.3536",
                      y2: "28.6464",
                      stroke: "white",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isOpen
        ? _c("div", {
            staticClass: "absolute w-screen h-screen z-10 top-0 left-0",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$emit("close")
              },
            },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }